var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-selete" },
    [
      _c(
        "van-popup",
        {
          attrs: { position: "bottom", "lock-scroll": false },
          on: { close: _vm.close },
          model: {
            value: _vm.showPop,
            callback: function ($$v) {
              _vm.showPop = $$v
            },
            expression: "showPop",
          },
        },
        [
          _c("van-picker", {
            attrs: {
              title: "",
              "show-toolbar": "",
              "default-index": _vm.defaultIndex,
              columns: _vm.columns,
              "cancel-button-text": _vm.$t("lang.cfm.cancelBtn"),
              "confirm-button-text": _vm.$t("lang.confirm"),
            },
            on: { confirm: _vm.confirm, cancel: _vm.cancel },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }